import { Cell, Pie, PieChart, Tooltip, Legend } from "recharts";
import { numberFormatter } from "../../../utils";

const GeneratePieChartImage = (props: any) => {
	let district = props.data.district;
	let piedata = props.data.costData;

	const CustomTooltip1 = ({ active, payload, district }: any) => {
		if (active && payload?.length) {
			const data = payload[0].payload;

			const popupStyle = {
				width: "12vw",
				background: "white",
				border: "1px solid #ccc",
				boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
				borderRadius: "1vh",
				cursor: "pointer",
				color: "black",
			};

			return (
				<div style={popupStyle}>
					{/* Header Row */}
					<div className="w-full flex justify-start h-[3vh] items-center bg-[#f0f4f8] py-[3vh] px-[1vh] textSmall">
						<div className="font-bold uppercase">District:</div>
						<div
							className="font-bold ml-1"
							style={{ color: "#3f3f3f" }}
						>
							{district}
						</div>
					</div>
					{/* Data Rows */}
					<div className="h-fit p-[1vh] mt-[.5vh] mb-[.5vh]">
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label-small"
								style={{
									color: "#5a5a5a",
									fontWeight: "normal",
								}}
							>
								Supplier:{" "}
							</label>
							<label
								className="graph-label-small"
								style={{
									color: "#3f3f3f",
									fontWeight: "bold",
								}}
							>
								{data.supplier}
							</label>
						</p>
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label-small"
								style={{
									color: "#5a5a5a",
									fontWeight: "normal",
								}}
							>
								Cost:{" "}
							</label>
							<label
								className="graph-label-small"
								style={{
									color: "#3f3f3f",
									fontWeight: "bold",
								}}
							>
								{numberFormatter(data.cost, 0)}%
							</label>
						</p>
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label-small"
								style={{
									color: "#5a5a5a",
									fontWeight: "normal",
								}}
							>
								Net Cost:{" "}
							</label>
							<label
								className="graph-label-small"
								style={{
									color: "#3f3f3f",
									fontWeight: "bold",
								}}
							>
								{numberFormatter(data.netcost, 0, "$")}
							</label>
						</p>
					</div>
				</div>
			);
		}
		return null;
	};

	const CustomLegend1 = () => {
		return (
			<div style={{ marginBottom: "-2vh", textAlign: "center" }}>
				<label
					style={{
						color: "#000000",
						fontSize: "1.5vh",
						fontWeight: "normal",
					}}
				>
					{district}
				</label>
			</div>
		);
	};

	return (
		<PieChart width={50} height={50} style={{ marginBottom: "-7vh" }}>
			<Pie
				data={piedata}
				labelLine={false}
				outerRadius={25}
				fill="#8884d8"
				dataKey="cost"
			>
				{piedata?.map((entry: any, index: any) => (
					<Cell key={`cell-${index}`} fill={entry.color} />
				))}
			</Pie>
			<Tooltip content={<CustomTooltip1 />} />
			<Legend content={<CustomLegend1 />} />
		</PieChart>
	);
};

export default GeneratePieChartImage;
